import { useSelector } from "react-redux";
import { getFormAuthority } from "../auth/authHelper";

const useFirstAndLastAuthorizedTab = ({ section = null, module = null }) => {
  const auth = useSelector((state) => state.user.permissions[module]);
  const getTempFormTabs = () => {
    let tempFormTab = [];
    for (let { form, tab } of Object.values(section)) {
      const { view } = getFormAuthority(auth, form, false);
      if (view && tab !== 0) {
        tempFormTab.push({
          form: form,
          tab: tab,
        });
      }
    }
    return tempFormTab.sort((a, b) => a.tab - b.tab);
  };

  return getTempFormTabs().length > 0
    ? {
        firstViableTab: getTempFormTabs()[0].tab,
        lastViableTab: getTempFormTabs()[getTempFormTabs().length - 1].tab,
      }
    : {
        firstViableTab: -1,
        lastViableTab: -1,
      };
};

export default useFirstAndLastAuthorizedTab;
